import { z } from 'zod';

import { AdvisorDataZod } from 'types/zod/advisor-data';
import { AssignedRoleZod } from 'types/zod/assigned-role';
import { DocumentZod } from 'types/zod/document';
import { ParticipantZod } from 'types/zod/participant';
import { ParticipantInDocumentZod } from 'types/zod/participant-in-document';
import { PlanCodeZod } from 'types/zod/plan-code';

export const CommunityZod = z.object({
    assigned: z.array(
        z.object({
            full_name: z.string(),
            participant_id: z.number(),
            documentsLocation: z.string().nullable().optional(),
            roles: z.array(AssignedRoleZod),
        }),
    ),
    docs: z.array(DocumentZod),
    plan: PlanCodeZod.nullable().optional(),
    realm: z.array(ParticipantInDocumentZod),
    secured: z.any(),
    tabs: z.array(z.number()),
    advisorData: AdvisorDataZod.nullable(),
    documentsLocation: z.string().nullable().optional(),
    advisorParticipantIds: ParticipantZod.shape.participant_id.array().optional(),
});
export type Community = z.infer<typeof CommunityZod>;
